export default __webpack_public_path__ + "static/media/bakertilly.c927c25d.svg";